import { Context, Controller } from '@hotwired/stimulus';
import { emitter } from 'src/emitter';

export default class TodosFormController extends Controller {
  public static targets = ['resolve'];
  public static values = {
    'assigned-user': String,
    'current-user': String,
    'not-a-participant-dialog': String,
    participants: String,
  };

  declare private resolveTargets: readonly HTMLButtonElement[];

  declare private assignedUserValue: string;
  declare private currentUserValue: string;
  declare private participantsValue: string;
  declare private notAParticipantDialogValue: string;

  declare private hasNotAParticipantDialogValue: boolean;

  constructor(context: Context) {
    super(context);

    this.onAssigned = this.onAssigned.bind(this);
  }

  connect(): void {
    emitter.on('todos:assigned', this.onAssigned);
  }

  disconnect(): void {
    emitter.off('todos:assigned', this.onAssigned);
  }

  private onAssigned(params: unknown) {
    if (!params || typeof params !== 'object') {
      return;
    }

    if (!Object.prototype.hasOwnProperty.call(params, 'value')) {
      return;
    }

    const assigned = (params as { value: string | null }).value;
    this.assignedUserValue = assigned || '';

    if (this.hasNotAParticipantDialogValue) {
      if (this.assignedUserValue == this.currentUserValue) {
        this.resolveTargets.forEach((button) => {
          if (
            button.getAttribute('data-confirm-dialog') ===
            this.notAParticipantDialogValue
          ) {
            button.removeAttribute('data-confirm');
            button.removeAttribute('data-confirm-dialog');
          }
        });
      } else {
        this.resolveTargets.forEach((button) => {
          if (!button.hasAttribute('data-confirm-dialog')) {
            button.setAttribute('data-confirm', 'Are you sure?');
            button.setAttribute(
              'data-confirm-dialog',
              this.notAParticipantDialogValue,
            );
          }
        });
      }
    }
  }
}
